<template>
	<div>
		<v-card 
			class="text-center mx-auto"
			:max-width="maxWidth"
			:width="width"
			flat
		>
			<v-card-item>
				<v-card-title :class="titleClass">
					{{ title }}
				</v-card-title>
				<v-card-subtitle :class="subtitleClass">
					<span class="text-wrap">{{ subtitle }}</span>
				</v-card-subtitle>
			</v-card-item>
			<!-- <v-card-text>
				{{ text }}
			</v-card-text> -->
			<v-card-text class="text-center" v-scroll="onScroll">
				<z-dialog-camera v-if="['all','camera'].includes(mode)"
					multiple
					fullscreen
					@ok="changeCamera"
				>
					<template v-slot:activator="{ props }">
						<v-btn v-bind="props" icon="mdi-camera-plus" size="x-large" flat></v-btn>
					</template>
				</z-dialog-camera>
				
				<v-btn v-if="['all','file'].includes(mode)" 
					icon="mdi-paperclip-plus"
					size="x-large"
					flat
					@click="$refs.fileinput.click()"
				></v-btn>
			</v-card-text>
			<v-card-text>
				<!-- <v-row class="my-3 mx-3" justify="center"> -->
				<v-row justify="center">
					<v-col v-for="(item, i) in items" :key="i"
						class="d-flex child-flex"
						cols="12"
						md="6"
					>
						<v-img 
							:src="item.url"
							cover
							@click="$refs.dialogImage.onOpen(i)"
						></v-img>
					</v-col>
				</v-row>
			</v-card-text>
		</v-card>

		<!-- <div class="font-weight-bolt text-secondary text-wrap text-center">
			{{ title }} <span v-if="changed"><v-icon icon="mdi-file-edit" size="x-small"></v-icon></span>
		</div>
		<div class="mt-6 text-center" v-scroll="onScroll">
			<z-dialog-camera v-if="['all','camera'].includes(mode)"
				multiple
				fullscreen
				@ok="changeCamera"
			>
				<template v-slot:activator="{ props }">
					<v-btn v-bind="props" icon="mdi-camera-plus" size="x-large" flat></v-btn>
				</template>
			</z-dialog-camera>
			
			<v-btn v-if="['all','file'].includes(mode)" 
				icon="mdi-paperclip-plus"
				size="x-large"
				flat
				@click="$refs.fileinput.click()"
			></v-btn>
		</div>
		<div  class="text-caption text-red-lighten-1" v-html="subtitle"></div>

		<v-row class="my-3 mx-3" justify="center">
			<v-col v-for="(item, i) in items" :key="i"
				class="d-flex child-flex"
				cols="12"
				md="6"
			>
				<v-img 
					:src="item.url"
					cover
					@click="$refs.dialogImage.onOpen(i)"
				></v-img>
			</v-col>
		</v-row> -->

	<!-- <div class="bg-surface-variant pa-4 position-relative rounded-lg ma-2">
		<div class="bg-surface-variant pa-4 position-relative rounded-lg ma-2">
			<div class="bg-surface-light position-relative py-3 ps-3">
				<div class="position-absolute top-0 left-0 right-0 bg-primary pa-3 w-100">
					{{ title }}
				</div>

				<div class="mt-6 text-center">
					<z-dialog-camera v-if="['all','camera'].includes(mode)"
						multiple
						fullscreen
						@ok="changeCamera"
					>
						<template v-slot:activator="{ props }">
							<v-btn v-bind="props" icon="mdi-camera-plus" size="x-large" flat></v-btn>
						</template>
					</z-dialog-camera>
					
					<v-btn v-if="['all','file'].includes(mode)" 
						icon="mdi-paperclip-plus"
						size="x-large"
						flat
						@click="$refs.fileinput.click()"
					></v-btn>
				</div>

				<div class="overflow-y-auto pe-3" style="max-height: 250px">
					<div  class="text-caption text-red-lighten-1" v-html="subtitle"></div>
					<v-row class="my-3 mx-3" justify="center">
						<v-col v-for="(item, i) in items" :key="i"
							class="d-flex child-flex"
							cols="12"
							md="6"
						>
							<v-img 
								:src="item.url"
								cover
								@click="$refs.dialogImage.onOpen(i)"
							></v-img>
						</v-col>
					</v-row>
				</div>
			</div>
		</div> -->

		<!-- <div class="font-weight-bolt text-secondary text-wrap text-center">
			{{ title }} <span v-if="changed"><v-icon icon="mdi-file-edit" size="x-small"></v-icon></span>
		</div> -->
		<!-- <v-toolbar class="position-sticky top-0" style="z-index: 10;">
			<v-toolbar-title>Fixed Header</v-toolbar-title>
		</v-toolbar> -->

		

		<!-- <div class="mt-6 text-center" style="position: sticky; top: 0; z-index: 2;"> -->
		
		
		<!-- <v-app-bar density="compact"  flat fixed v-if="visible" extended>
			<v-app-bar-title>
				<div class="font-weight-bolt text-secondary text-wrap text-center">
					{{ title }} <span v-if="changed"><v-icon icon="mdi-file-edit" size="x-small"></v-icon></span>
				</div>
			</v-app-bar-title>
			<template v-slot:extension>
				<v-row class="mt-6 text-center">
					<v-col cols="12">
						<z-dialog-camera v-if="['all','camera'].includes(mode)"
							multiple
							fullscreen
							@ok="changeCamera"
						>
							<template v-slot:activator="{ props }">
								<v-btn v-bind="props" icon="mdi-camera-plus" size="x-large" flat></v-btn>
							</template>
						</z-dialog-camera>
						
						<v-btn v-if="['all','file'].includes(mode)" 
							icon="mdi-paperclip-plus"
							size="x-large"
							flat
							@click="$refs.fileinput.click()"
						></v-btn>
					</v-col>
					<v-col cols="12">
						<div  class="text-caption text-red-lighten-1" v-html="subtitle"></div>
					</v-col>
				</v-row>
			</template>
		</v-app-bar> -->

		<!-- <div>
			<z-dialog-camera v-if="['all','camera'].includes(mode)"
				@ok="changeCamera" 
				multiple
				:fullscreen="isMobile" 
			>
				<template v-slot:activator="{ props }">
					<v-btn v-bind="props" icon="mdi-camera-plus" size="x-large" flat></v-btn>
				</template>
			</z-dialog-camera>
			
			<v-btn v-if="['all','file'].includes(mode)" 
				icon="mdi-paperclip-plus"
				size="x-large"
				flat
				@click="$refs.fileinput.click()"
			></v-btn>
		</div> -->

		<!-- <div v-if="!isValid" class="text-caption text-red-lighten-1">Обов'язкове для заповнення</div> -->

		<!-- <div class="v-messages">Обов'язкове для заповнення</div> -->
		<!-- <v-row class="my-3 mx-3">
			<v-card v-for="(item, i) in items" :key="i"
				class="ma-1"
				height="64"
				width="64"
				elevation="3"
			>
				<v-img 
					:src="item.url"
					:aspect-ratio="1"
					cover
					@click="$refs.dialogImage.onOpen(i)"
				></v-img>
			</v-card>
		</v-row> -->
		<!-- <v-row class="my-3 mx-3" justify="center">
			<v-col v-for="(item, i) in items" :key="i"
				class="d-flex child-flex"
				cols="12"
				md="6"
			>
				<v-img 
					:src="item.url"
					cover
					@click="$refs.dialogImage.onOpen(i)"
				></v-img>
			</v-col>
		</v-row> -->

		<!-- <v-btn style="bottom: 40px; z-index: 2004"
			v-show="fab"
			icon="mdi-plus"
			color="primary"
			position="fixed"
			location="bottom right"
			class="ma-6"
		></v-btn> -->
		<z-dialog-camera v-if="['all','camera'].includes(mode)" 
			multiple
			fullscreen
			@ok="changeCamera"
		>
			<template v-slot:activator="{ props }">
				<v-btn v-bind="props"
					style="bottom: 128px; z-index: 2004"
					icon="mdi-camera-plus"
					size="x-large" flat
					v-show="fab"
					position="fixed"
					location="bottom right"
				></v-btn>
			</template>
		</z-dialog-camera>
		
		<v-btn v-if="['all','file'].includes(mode)" 
			style="bottom: 60px; z-index: 2004"
			v-show="fab"
			position="fixed"
			location="bottom right"
			icon="mdi-paperclip-plus"
			size="x-large"
			flat
			@click="$refs.fileinput.click()"
		></v-btn>
		

		<v-progress-linear v-if="loading"
			color="indigo"
			:height="1"
			indeterminate
		></v-progress-linear>

		<!-- <v-divider></v-divider> -->

		<z-dialog-image 
			ref="dialogImage"
			:items="items"
			@remove="remove"
			multiple
			:loading="loading"
		></z-dialog-image>

		<v-file-input 
			ref="fileinput"
			v-model="file"
			class="d-none"
			:multiple="multiple"
			@update:modelValue="changeFile"
		></v-file-input>
	</div>
</template>

<script>
import zDialogImage from '@/components/dialogs/ImageFullscreen'
//import zDialogCamera from '@/components/dialogs/Camera'
import zDialogCamera from '@/components/dialogs/Camera2'
import EXIF from 'exif-js'
import piexif from 'piexifjs'
//import pngtojpeg from 'png-to-jpeg'
import { useDisplay } from 'vuetify'

export default {
	name: 'Photo',
	components: {
		zDialogImage,
		zDialogCamera
	},
	data: () => ({
		file: null,
		validateText: '',
		isMobile: false,

		fab: false,
	}),
    props: {
		modelValue: 	{ type: Array, default: () => []},
		mode: 			{ type: String, default: 'all'}, // camera | file | all
		title: 			{ type: String, default: null},
		subtitle: 		{ type: String, default: null},
		description: 	{ type: String, default: null},
		text: 			{ type: String, default: null},
		icon: 			{ type: String, default: 'mdi-halloween'},
		stacked: 		{ type: Boolean, default: false},
		multiple: 		{ type: Boolean, default: true},
		counter: 		{ type: Boolean, default: true},
		min: 			{ type: Number, default: null},
		max: 			{ type: Number, default: null},
		loading: 		{ type: Boolean, default: false},
		required: 		{ type: Boolean, default: false},
		resolution:		{ type: Object, default: () => ({ width: 1920, height: 1080 }) },
		//resolution:		{ type: Object, default: () => ({ width: 800, height: 600 }) },
		fileName: 		{ type: String, default: 'Фото з камери'},
		visible:		{ type: Boolean, default: false },
		changed:		{ type: Boolean, default: false },
    },

    computed: {
		items: {
			get() 		{ return this.modelValue },
			set(val) 	{ this.$emit('update:modelValue', val) }
		},

		count() {
			return this.items.length
		},

		isValid() {
			return this.required && this.items.length == 0 ? false : true
		},
    },

	created() {
		const { mobile, smAndDown, smAndUp } = useDisplay()
		this.isMobile = mobile.value

		//smAndDown: boolean // < 960
 	 	//smAndUp: boolean // > 600
		//console.log(this.$options.name, 'created', 'type', this.type)
		//console.log(this.$options.name, 'created', 'mobile', mobile.value)
		//console.log(this.$options.name, 'created', 'smAndDown', smAndDown.value)
		//console.log(this.$options.name, 'created', 'smAndUp', smAndUp.value)
	},

	methods: {
		onScroll(e) {
			//const scrollTop = e.target.scrollTop
  			console.log(e)
			if (typeof window === 'undefined') return;
			// Show button after scrolling 100px
			this.fab = window.pageYOffset > 100;
		},

		validate() {
			//console.log(this.$options.name, 'validate')

			const p = new Promise((resolve, reject) => {
				if(this.required && this.items.length == 0) {
					resolve({errors: [], valid: false});
				} else {
					resolve({errors: [], valid: true});
				}
			});

			//console.log(this.$options.name, 'validate', 'p' , p)

			return p
		},

		remove(e) {
			if(e) {
				//this.$emit('remove', e)
				const index = this.items.indexOf(e)
				this.items.splice(index, 1);

				this.$emit('change')
			}
		},

		changeCamera(e) {
			//console.log(this.$options.name, 'changeCamera', 'e', e)

			if(e) {
				if(Array.isArray(e)) {
					e.forEach((element) => {
						this.addCamera(element)
					})
				} else {
					this.addCamera(e)
				}
			}
		},

		addCamera(blob) {
			//console.log(this.$options.name, 'add', source, 'blob', blob)

			let extension = 'jpg'
			switch(blob.type) {
				case 'image/png': extension = 'png'; break;
			}

			const fileName = `${this.fileName}.${extension}`;
			const fileBits = [blob];
			let file = new File(fileBits, fileName, {
				type: blob.type,
				lastModified: Date.now()
			});

			/*
			const fileName = `${this.fileName}.jpg`;
			const fileBits = [blob];
			let file = new File(fileBits, fileName, {
				//type: blob.type,
				type: 'image/jpeg',
				lastModified: Date.now()
			});
			*/

			
			/* var exif = null;
			this.toJPEG(file).then((f) => file = f)
			.then(() => this.setExif(file)).then((f) => file = f)
			//.then(() => this.getExif(file)).then((e) => exif = e)
			.finally(() => {
				//console.log(this.$options.name, 'addCamera::finally', 'exif', exif)
				//console.log(this.$options.name, 'addCamera::finally', 'file', file)

				this.addFile(file, 'camera')
			}); */
			
			/* this.setExif(file).then((f) => file = f)
			.finally(() => {
				//console.log(this.$options.name, 'addCamera::finally', 'exif', exif)
				//console.log(this.$options.name, 'addCamera::finally', 'file', file)
				this.addFile(file, 'camera')
			}); */

			//console.log(this.$options.name, 'addCamera', 'file', file)

			this.addFile(file, 'camera')
		},

		changeFile(e) {
			//console.log(this.$options.name, 'changeFile', 'e', e)
			if(e) {
				if(Array.isArray(e)) {
					e.forEach((element) => {
						let file = this.renameFile(element, )
						this.addFile(file)
					})
				} else {
					this.addFile(e)
				}
			}

			this.file = null
		},

		/* addFile(file, source) {
			console.log(this.$options.name, 'addFile', 'source', source, 'file', file)
			if(file) {
				const url = URL.createObjectURL(file);
					
				this.items.push({
					source: source ? source : 'file',
					url: url,
					file: file,
					//exif: exif
				})
			}
		}, */

		addFile(file, source) {
			//console.log(this.$options.name, 'addFile', 'source', source, 'file', file)

			if(file) {
				let original = this.renameFile(file, this.fileName),
					name = file.name,
					size = file.size,
					mime = file.type,
					lastModified = file.lastModified
				;
				//file = this.renameFile(file, this.fileName)

				file = new File([original], original.name, { type: original.type, lastModified: original.lastModified })


				var exif = null;
				this.getExif(file)
				//.then((e) => exif = e)
				//.then(() => this.resizeFile(file))
				//.then((fl) => file = fl)
				//.then(() => this.copyExif(original, file))
				//.then((fl) => file = fl)
				
				/*
				const modifNewfile = that.copyExif(file, newfile);

							console.log(that.$options.name, 'resizeFile', 'modifNewfile', modifNewfile)

							resolve(modifNewfile);
				*/
				.finally(() => {
					//console.log(this.$options.name, 'addFile::finally', 'exif', exif)
					//console.log(this.$options.name, 'addFile::finally', 'file', file)
					
					const url = URL.createObjectURL(file);
					
					/* this.$emit('add', {
						source: source ? source : 'file',
						url: url,
						file: file,
						exif: exif
					}) */

					this.items.push({
						name: name,
						originalName: name,
						size: size,
						mime: mime,
						lastModified: lastModified,
						source: { 
							code: source ? source : 'file'
						},
						url: url,
						file: file,
						exif: exif
					})

					this.$emit('change')
				});
			}
		},

		/**
		 * Rename of File
		 * @param originalFile - оригінальний файл
		 * @param newName - нова назва без розширення
		 */
		renameFile(originalFile, newName) {
			//var re = /(?:\.([^.]+))?$/;
			//const extention = re.exec(originalFile.name)[1];
			const extention = originalFile.name.split('.').pop();
			const fileName = `${newName}.${extention}`;

			return new File([originalFile], fileName, {
				type: originalFile.type,
				lastModified: originalFile.lastModified,
			});
		},

		/**
		 * Resizing the File
		 * https://cloudinary.com/guides/bulk-image-resize/transform-your-visuals-how-to-resize-an-image-in-javascript
		 * @param file 
		 */
		async resizeFile(file) {
			//console.log(this.$options.name, 'resizeFile', 'file', file)

			var that = this

			//const dataURL = URL.createObjectURL(file);
			//var exif = piexif.load(dataURL);

			//var exif = await this.getExif(file);
			//console.log(this.$options.name, 'resizeFile', 'exif', exif)


			/* var dataURL = await this.getDataURL(file);

			console.log(this.$options.name, 'resizeFile', 'dataURL', dataURL)

			var exifObj = piexif.load(dataURL);

			console.log(this.$options.name, 'resizeFile', 'exifObj', exifObj)

			var exifStr = piexif.dump(exifObj) // Get exif as string to insert into JPEG.

			console.log(this.$options.name, 'resizeFile', 'exifStr', exifStr) */

			//var exifObj = await this.setExifObject(file);
			//console.log(this.$options.name, 'resizeFile', 'exifObj', exifObj);

			return await new Promise(resolve => {
				if(file.size > 2*1024*1024) {
					var img = new Image();
					img.src = URL.createObjectURL(file);
					img.onload = function() {
						//console.log(that.$options.name, 'addFile', 'width', this.width, 'height', this.height, 'img', this)

						var maxWidth = that.resolution.width; // Define the maximum width of the image
						var maxHeight = that.resolution.height; // Define the maximum height of the image

						var width = this.width;
						var height = this.height;

						// Calculate the new dimensions, maintaining the aspect ratio
						if (width > height) {
							if (width > maxWidth) {
								height *= maxWidth / width;
								width = maxWidth;
							}
						} else {
							if (height > maxHeight) {
								width *= maxHeight / height;
								height = maxHeight;
							}
						}

						// Set the canvas dimensions to the new dimensions
						var canvas = document.createElement('canvas');
						canvas.width = width;
						canvas.height = height;

						// Draw the resized image on the canvas
						var ctx = canvas.getContext('2d');
						ctx.drawImage(this, 0, 0, width, height);

						//console.log(this.$options.name, 'resizeFile', 'canvas.width', canvas.width, 'canvas.height', canvas.height)
						//console.log(this.$options.name, 'resizeFile', 'image.width', image.width, 'image.height', image.height)
						
						const quality = 1.0
						canvas.toBlob((blob) => {
							const newfile = new File([blob], file.name, {
								type: file.type,
								lastModified: file.lastModified
							});

							resolve(newfile);

						}, "image/jpeg", quality);
						
					};
				} else {
					resolve(file); 
				}
			});
		},

		/**
		 * Resizing to JPEG
		 * @param file 
		 */
		
		/* convertDataURIToBinary(dataURI) {
			var BASE64_MARKER = ';base64,';
			var base64Index = dataURI.indexOf(BASE64_MARKER) + BASE64_MARKER.length;
			var base64 = dataURI.substring(base64Index);
			var raw = window.atob(base64);
			var rawLength = raw.length;
			var array = new Uint8Array(new ArrayBuffer(rawLength));

			for (let i = 0; i < rawLength; i++) {
				array[i] = raw.charCodeAt(i);
			}
			return array;
		}, */

		/* getBase64Image(img) {
			// Создаем пустой canvas
			var canvas = document.createElement("canvas");
			canvas.width = img.width;
			canvas.height = img.height;

			// Копируем изображение в контекст canvas'a
			var ctx = canvas.getContext("2d");
			ctx.drawImage(img, 0, 0);

			// Получаем data-URL изображения
			return canvas.toDataURL("image/png");

			//return dataURL.replace(/^data:image\/(png|jpg);base64,/, "");
		}, */

		async getDataURL(file) {
			//return await new Promise(resolve => {
			return new Promise(resolve => {

				var img = new Image();
				img.src = URL.createObjectURL(file);
				img.onload = function() {
					var width = this.width,
						height = this.width
					;

					var canvas = document.createElement("canvas");
					canvas.width = width;
					canvas.height = height;
					//canvas.getContext("2d").drawImage(img, 0, 0);

					// Копируем изображение в контекст canvas'a
					var ctx = canvas.getContext("2d");
					ctx.drawImage(img, 0, 0);

					var dataURL  = canvas.toDataURL(file.type);

					resolve(dataURL);
				}
			})
		},

		async toJPEG(file) {
			//console.log(this.$options.name, 'toJPEG', 'file', file)

			var that = this
			return await new Promise(resolve => {
				//console.log(that.$options.name, 'toJPEG', 'file.type', file.type)
				if(file.type == 'image/jpeg') {
					resolve(file);
				} else {

					//console.log(that.$options.name, 'toJPEG', 'file.type', file.type)
					//console.log(that.$options.name, 'toJPEG', 'file.nativeURL', file.nativeURL)

					var img = new Image();
					img.src = URL.createObjectURL(file);
					img.onload = function() {
						var width = img.naturalWidth,
							height = img.naturalHeight;

						//console.log(width, height)
						window.URL.revokeObjectURL( img.src );

						var canvas = document.createElement("canvas");
						canvas.width = width;
						canvas.height = height;
						//canvas.getContext("2d").drawImage(img, 0, 0);

						// Копируем изображение в контекст canvas'a
						var ctx = canvas.getContext("2d");
						ctx.drawImage(img, 0, 0);

						var img_link    = canvas.toDataURL("image/jpeg");

						
						//console.log(img_link)
						//jpg.src = img_link

						//that.setExif(img_link)

						const quality = 1.0
						canvas.toBlob((blob) => {
							//console.log(that.$options.name, 'toJPEG', 'blob', blob)

							const extention = 'jpg';						
							const fileName = file.name.replace(/\.[^/.]+$/, "")+`.${extention}`;

							const newfile = new File([blob], fileName, { type: blob.type });

							//console.log(that.$options.name, 'toJPEG', 'newfile', newfile)

							//const url = URL.createObjectURL(newfile);
							//console.log(that.$options.name, 'toJPEG', 'url', url)

							resolve(newfile);
						}, "image/jpeg", quality);
					}
				}
			})
			
		},

		/**
		 * EXIF meta data from image files
		 * https://github.com/exif-js/exif-js
		 * https://www.npmjs.com/package/exif-js
		 */
		async getExif(file) {
			//console.log(this.$options.name, 'getExif', 'file', file)
			//return await new Promise(resolve =>
			return new Promise(resolve =>
				EXIF.getData(file, function() {
					//console.log('getExif', 'exif', EXIF.getAllTags(this))
					resolve(EXIF.getAllTags(this)); 
				}
			));
		},

		async setExifObject(file) {
			return new Promise(resolve => {
				var reader = new FileReader();
				reader.onloadend = function(e) {
					var exifObj = piexif.load(e.target.result);
					//console.log(that.$options.name, 'resizeFile', 'exifObj', exifObj)
					resolve(exifObj);
				};
				reader.readAsDataURL(file);
			});
		},

		/**
		 * Copy EXIF from fileSource to fileTarget
		 * https://piexifjs.readthedocs.io/en/latest/sample.html
		 */
		async copyExif(fileSource, fileTarget) {
			//console.log(this.$options.name, 'copyExif', 'fileSource', fileSource)
			//console.log(this.$options.name, 'copyExif', 'fileTarget', fileTarget)

			var that = this
			return new Promise(resolve => {
				var readerSource = new FileReader();
				readerSource.onloadend = function(es) {
					var exifObj = piexif.load(es.target.result);
					var exifStr = piexif.dump(exifObj);
					//console.log(that.$options.name, 'copyExif', 'exifObj', exifObj)

					var readerTarget = new FileReader();
					readerTarget.onloadend = function(et) {
						//console.log(that.$options.name, 'copyExif', 'et', et)

						var jpegData = et.target.result;

						//console.log(that.$options.name, 'copyExif', 'jpegData', jpegData)

						var exifModified = piexif.insert(exifStr, jpegData);

						var jpegBinary = atob(exifModified.split(",")[1]);
						var data = [];
						for (var p=0; p<jpegBinary.length; p++) {
							data[p] = jpegBinary.charCodeAt(p);
						}
						var ua = new Uint8Array(data);
						var blob = new Blob([ua], {type: fileTarget.type});

						const newfile = new File([blob], fileTarget.name, {
							type: fileTarget.type,
							lastModified: fileTarget.lastModified
						});

						//console.log(that.$options.name, 'copyExif', 'newfile', newfile)

						resolve(newfile);
					};
					readerTarget.readAsDataURL(fileTarget);

				};
				readerSource.readAsDataURL(fileSource);
			});
		},


		/**
		 * EXIF meta data from image files
		 * https://github.com/exif-js/exif-js
		 * https://www.npmjs.com/package/exif-js
		 */
		async setExif(file) {
			//console.log(this.$options.name, 'setExif', 'file', file)

			//const url = URL.createObjectURL(file);
			//console.log(this.$options.name, 'setExif', 'url', url)

			var jpegData = await this.getDataURL(file);

			//var jpegData = document.getElementById("canvas").toDataURL("image/jpeg", 1.0);

			var that = this
			return await new Promise(resolve => {
				var zeroth = {};
				var exif = {};
				var gps = {};
				zeroth[piexif.ImageIFD.Make] = "Make";
				zeroth[piexif.ImageIFD.XResolution] = [777, 1];
				zeroth[piexif.ImageIFD.YResolution] = [777, 1];
				zeroth[piexif.ImageIFD.Software] = "GreenDoor";
				//exif[piexif.ExifIFD.DateTimeOriginal] = "2010:10:10 10:10:10";
				//exif[piexif.ExifIFD.DateTimeOriginal] = Date.now();
				exif[piexif.ExifIFD.DateTimeOriginal] = (new Date()).toISOString();
				exif[piexif.ExifIFD.LensMake] = "LensMake";
				exif[piexif.ExifIFD.Sharpness] = 777;
				exif[piexif.ExifIFD.LensSpecification] = [[1, 1], [1, 1], [1, 1], [1, 1]];
				gps[piexif.GPSIFD.GPSVersionID] = [7, 7, 7, 7];
				//gps[piexif.GPSIFD.GPSDateStamp] = "1999:99:99 99:99:99";
				gps[piexif.GPSIFD.GPSDateStamp] = (new Date()).toISOString();

				//gpsIfd[piexif.GPSIFD.GPSLatitudeRef] = lat < 0 ? 'S' : 'N';
				//gpsIfd[piexif.GPSIFD.GPSLatitude] = piexif.GPSHelper.degToDmsRational(lat);
				//gpsIfd[piexif.GPSIFD.GPSLongitudeRef] = lng < 0 ? 'W' : 'E';
				//gpsIfd[piexif.GPSIFD.GPSLongitude] = piexif.GPSHelper.degToDmsRational(lng);

				var exifObj = {"0th":zeroth, "Exif":exif, "GPS":gps};
				//var exifStr = piexif.dump(exifObj);


				// get exif binary as "string" type
				var exifBytes = piexif.dump(exifObj);

				// get JPEG image from canvas
				//var jpegData = document.getElementById("canvas").toDataURL("image/jpeg", 1.0);

				// insert exif binary into JPEG binary(DataURL)
				var exifModified = piexif.insert(exifBytes, jpegData);

				var jpegBinary = atob(exifModified.split(",")[1]);
				var data = [];
				for (var p=0; p<jpegBinary.length; p++) {
					data[p] = jpegBinary.charCodeAt(p);
				}
				var ua = new Uint8Array(data);
				var blob = new Blob([ua], {type: "image/jpeg"});

				const newfile = new File([blob], file.name, {
					type: file.type,
					lastModified: file.lastModified
				});

				//console.log(that.$options.name, 'setExif', 'newfile', newfile)

				resolve(newfile);
			});
		},
	},
}
</script>